import { observer } from 'mobx-react';
import { FC, ReactElement, useMemo } from 'react';
import DashboardPlate from '../../components/DashboardPlate/DashboardPlate';
import { DashboardPlates as DashboardPlatesEnum } from '../../constants/dashboard';
import { dashboardStore } from '../../store/dashboardStore';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import { SCREENS } from '~/constants/screens';

const DashboardPlates: FC = observer((): ReactElement => {
  const { dashboardPermission, isMonthFilter } = dashboardStore;

  const salesPeriodReportPath = useMemo((): string => (isMonthFilter ? SCREENS.MONTH_YEAR_SALES() : SCREENS.DAY_WEEK_SALES()), [isMonthFilter]);

  return (
    <div className="d-flex flex-row gap-20">
      {dashboardPermission[DashboardPlatesEnum.ORDERS].showPlate ? (
        <DashboardPlate
          type={DashboardPlatesEnum.ORDERS}
          title="orders"
          mainHeader="total_number_of_orders"
          mainHeaderTooltip={{ message: 'total_number_of_orders_tooltip', position: TOOLTIP_POSITION.FIXED, duration: TOOLTIP_DURATION.EXTRA_LARGE }}
          secondaryHeader="canceled_orders"
          secondaryHeaderTooltip={{ message: 'canceled_orders_tooltip', position: TOOLTIP_POSITION.FIXED, duration: TOOLTIP_DURATION.EXTRA_LARGE }}
          conclusionHeader="acceptance_rate"
          conclusionHeaderTooltip={{ message: 'acceptance_rate_tooltip', position: TOOLTIP_POSITION.FIXED, duration: TOOLTIP_DURATION.EXTRA_LARGE }}
          linkTitle="go_to_reports"
          linkPath={salesPeriodReportPath}
        />
      ) : null}

      {dashboardPermission[DashboardPlatesEnum.REVENUE].showPlate ? (
        <DashboardPlate
          type={DashboardPlatesEnum.REVENUE}
          title="revenue"
          mainHeader="total_revenue"
          mainHeaderTooltip={{ message: 'total_revenue_tooltip', position: TOOLTIP_POSITION.FIXED, duration: TOOLTIP_DURATION.EXTRA_LARGE }}
          secondaryHeader="average_check"
          secondaryHeaderTooltip={{ message: 'average_check_tooltip', position: TOOLTIP_POSITION.FIXED, duration: TOOLTIP_DURATION.EXTRA_LARGE }}
          conclusionHeader="payment_rate"
          conclusionHeaderTooltip={{ message: 'payment_rate_tooltip', position: TOOLTIP_POSITION.FIXED, duration: TOOLTIP_DURATION.EXTRA_LARGE }}
          linkTitle="go_to_reports"
          linkPath={salesPeriodReportPath}
        />
      ) : null}

      {dashboardPermission[DashboardPlatesEnum.CRM].showPlate ? (
        <DashboardPlate
          type={DashboardPlatesEnum.CRM}
          title="customers"
          mainHeader="total_customers"
          mainHeaderTooltip={{ message: 'total_customers_tooltip', position: TOOLTIP_POSITION.FIXED, duration: TOOLTIP_DURATION.EXTRA_LARGE }}
          secondaryHeader="new_gained_customers"
          secondaryHeaderTooltip={{
            message: 'new_gained_customers_tooltip',
            position: TOOLTIP_POSITION.FIXED,
            duration: TOOLTIP_DURATION.EXTRA_LARGE,
          }}
          conclusionHeader="new_customers_rate"
          conclusionHeaderTooltip={{
            message: 'new_customers_rate_tooltip',
            position: TOOLTIP_POSITION.FIXED,
            duration: TOOLTIP_DURATION.EXTRA_LARGE,
          }}
          linkTitle="go_to_crm"
          linkPath={SCREENS.CRM_PROFILES()}
        />
      ) : null}

      {dashboardPermission[DashboardPlatesEnum.MARKETING].showPlate ? (
        <DashboardPlate
          type={DashboardPlatesEnum.MARKETING}
          title="marketing"
          mainHeader="promocodes_value"
          mainHeaderTooltip={{ message: 'promocodes_value_tooltip', position: TOOLTIP_POSITION.FIXED, duration: TOOLTIP_DURATION.EXTRA_LARGE }}
          secondaryHeader="promocodes_usage"
          secondaryHeaderTooltip={{ message: 'promocodes_usage_tooltip', position: TOOLTIP_POSITION.FIXED, duration: TOOLTIP_DURATION.EXTRA_LARGE }}
          conclusionHeader="avg_discount"
          conclusionHeaderTooltip={{ message: 'avg_discount_tooltip', position: TOOLTIP_POSITION.FIXED, duration: TOOLTIP_DURATION.EXTRA_LARGE }}
          linkTitle="go_to_marketing"
          linkPath={SCREENS.MARKETING()}
        />
      ) : null}
    </div>
  );
});

export default DashboardPlates;
